<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox11 min-w-1400">
      <div class="img11 max-w-1400">
        <p class="imgItem11">ข่าวของเรา</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img
          :src="showNewImage2 ? AllImg2 : importedImg2"
          :alt="altText"
          class="imgItem2"
        />
        <div class="btn2" @click="toggleNewImage(2)"></div>
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img
          :src="showNewImage3 ? AllImg3 : importedImg3"
          :alt="altText"
          class="imgItem3"
        />
        <div class="btn3" @click="toggleNewImage(3)"></div>
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <img
          :src="showNewImage4 ? AllImg4 : importedImg4"
          :alt="altText"
          class="imgItem4"
        />
        <div class="btn4" @click="toggleNewImage(4)"></div>
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <img
          :src="showNewImage5 ? AllImg5 : importedImg5"
          :alt="altText"
          class="imgItem5"
        />
        <div class="btn5" @click="toggleNewImage(5)"></div>
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <img
          :src="showNewImage6 ? AllImg6 : importedImg6"
          :alt="altText"
          class="imgItem6"
        />
        <div class="btn6" @click="toggleNewImage(6)"></div>
      </div>
    </div>
    <!-- <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div> -->
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/quick.mackale/components/img/5_1.png";
import importedImg2 from "@/page/quick.mackale/components/img/5_2.png";
import importedImg3 from "@/page/quick.mackale/components/img/5_3.png";
import importedImg4 from "@/page/quick.mackale/components/img/5_4.png";
import importedImg5 from "@/page/quick.mackale/components/img/5_5.png";
import importedImg6 from "@/page/quick.mackale/components/img/5_6.png";
// import importedImg7 from "@/page/quick.mackale/components/img/5_7.png";
import AllImg2 from "@/page/quick.mackale/components/img/5_2_2.png";
import AllImg3 from "@/page/quick.mackale/components/img/5_3_3.png";
import AllImg4 from "@/page/quick.mackale/components/img/5_4_4.png";
import AllImg5 from "@/page/quick.mackale/components/img/5_5_5.png";
import AllImg6 from "@/page/quick.mackale/components/img/5_6_6.png";
// import AllImg7 from "@/page/quick.mackale/components/img/5_7_7.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      importedImg6: importedImg6,
      // importedImg7: importedImg7,
      AllImg2: AllImg2,
      AllImg3: AllImg3,
      AllImg4: AllImg4,
      AllImg5: AllImg5,
      AllImg6: AllImg6,
      // AllImg7: AllImg7,

      altText: "图片",
      showNewImage2: false,
      showNewImage3: false,
      showNewImage4: false,
      showNewImage5: false,
      showNewImage6: false,
      showNewImage7: false,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    toggleNewImage(imageIndex) {
      //  console.log("点击了");
      //   this.$set(this.showNewImage, imageIndex, !this.showNewImage[imageIndex]);
      //   this.activeImage = imageIndex;
      console.log(this.showNewImage3);
      if (imageIndex == 2) {
        this.showNewImage2 = !this.showNewImage2;
      }
      if (imageIndex == 3) {
        this.showNewImage3 = !this.showNewImage3;
      }
      if (imageIndex == 4) {
        this.showNewImage4 = !this.showNewImage4;
      }
      if (imageIndex == 5) {
        this.showNewImage5 = !this.showNewImage5;
      }
      if (imageIndex == 6) {
        this.showNewImage6 = !this.showNewImage6;
      }
      if (imageIndex == 7) {
        this.showNewImage7 = !this.showNewImage7;
      }
    },
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7,
.imgBox11 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box,
.img11Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7,
.imgItem11 {
  width: 100%;
  margin: 0;
}

.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box {
  padding: 40px 200px 0;
}
.img6Box {
  margin-bottom:200px;
}

.img11 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 140px;
}
.imgItem11 {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}

.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box {
  position: relative;
}
.btn2,
.btn3,
.btn4,
.btn5,
.btn6 {
  /* border: 1px solid red; */
  cursor: pointer;
  position: absolute;
  height: 20px;
  width: 5%;
}
.btn2,
.btn4,
.btn6 {
  left: 14%;
  bottom: 0%;

}
.btn3,.btn5{
  right: 14%;
  bottom: 0%;
}
</style>
